import React from "react";
import UploadHeader from "../components/common/UploadHeader";
import ProductUploadForm from "../components/productUpload";

const ProductUpload = () => {
  return (
    <>
      <UploadHeader />
      <ProductUploadForm />
    </>
  );
};

export default ProductUpload;
